import React from 'react';
import { Heart, Target, Users, Globe } from 'lucide-react';

const MissionSection = () => {
  const values = [
    {
      icon: Heart,
      title: 'Compassion',
      description: 'Every child deserves safety, care, and protection from harm.'
    },
    {
      icon: Target,
      title: 'Evidence-Based',
      description: 'Our programs are built on proven research and best practices.'
    },
    {
      icon: Users,
      title: 'Collaboration',
      description: 'Working together with communities to create lasting change.'
    },
    {
      icon: Globe,
      title: 'Global Reach',
      description: 'Supporting child protection efforts across all 195 countries.'
    }
  ];

  return (
    <section id="mission" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Content */}
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
              Our Mission
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Empowering Communities to
              <span className="block text-blue-600">Protect Every Child</span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
              Child Advocacy Consulting is dedicated to preventing child abuse and neglect 
              through comprehensive training, expert consultation, and educational programs. 
              We work with organizations, professionals, and communities worldwide to create 
              safe environments where children can thrive.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div 
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-2">{value.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
